export const FAULT_MANAGER_PATH = 'api/rfg'

export enum EndPoints {
    GetFaultList = 'GetFaultList'
}
